import React, { Component } from "react";
import styled from "styled-components";
import { graphql, compose } from "react-apollo";
import { observer } from "mobx-react";
import {
  mutationReplyCase,
  mutationEscalateCase,
  mutationChatWithWhatsapp,
  queryGetOngkirCompany
} from "Apollo";
import { Config } from "constant";
import {
  CaseManagementStore,
  CommonStore,
  ResetMessage,
  ShowNotice
} from "Store";
import { pushNewStream } from "module-common/ServerSyncWithStoreQuerySubs"
import IconRaw from "module-common/Icon";
import Tooltip from "module-common/Tooltip";
import PickerAgent from "module-common/PickerAgentWithQuery";
import Picker from "module-common/Picker";
import SelectBox from "module-common/SelectBox";
import LabelPicker from "module-common/TreePickerMultiLabelWithQuery";
import AssignButton from "./assign-button/AssignButtonWithStoreMutation";
import ChannelLimit from "./ChannelLimit";
import Input from "./Input";
import Reply from "./Reply";
import Image from "./Image";
import Approver from "./Approver";
import TemplateReplyModal from "./TemplateReplyModal";
import SelectBoxSendWhatsapp from "module-common/SelectBoxSendWhatsapp";
import CekOngkirModal from "./CekOngkirModal";
import TemplateReplySuggestion from "./TemplateReplySuggestion";

export default compose(
  graphql(mutationReplyCase, {
    name: "sendMutate"
  }),
  graphql(mutationEscalateCase, {
    name: "escalateMutate"
  }),
  graphql(mutationChatWithWhatsapp, {
    name: "chatWithWhatsapp"
  })
)(
  observer(
    class Footer extends Component {
      state = {
        showModal: false,
        showOngkirModal: false,
        showOngkirButton: false
      };

      render() {
        const { selectedCase, replyLabels } = CaseManagementStore;
        const { replyLabelActive, nickActive, autoAssignActive } = CommonStore;
        if (selectedCase) {
          if (selectedCase.assignedTo) {
            const signature = CommonStore.me.agent.shortName;
            const usernameTwitter = CaseManagementStore.user;
            const message = CaseManagementStore.message;
            const fullMessage = nickActive
              ? `${usernameTwitter}` + message + ` -${signature}`
              : `${usernameTwitter}` + message;
            const channel = selectedCase.channel;
            const channelType = CaseManagementStore.channelType;
            const limit = channelType.limit - fullMessage.length;
            const imageUrl = CaseManagementStore.imageUrl;
            const approver = CaseManagementStore.approver;
            const autoAssignActive = CommonStore.autoAssignActive;

            // prepare channel options
            const channelOptions = [];
            let channelSelectBoxLabel = "";
            let defaultSelected = false;
            for (const chType of channel.channelSpecificType) {
              if (chType.isReplyMethod) {
                const selected = chType.id === ((channelType.id === 3 || channelType.id === 10) ? (channelType.id = 4) : channelType.id);
                if (selected) {
                  defaultSelected = true;
                  channelSelectBoxLabel = chType.name;
                }

                if (chType.name !== "post" && chType.name !== "review") {
                  channelOptions.push({
                    label: chType.name,
                    selected: selected,
                    value: chType
                  });
                }
              }
            }

            // check if there is any option selected, if not select first option
            if (!defaultSelected && channelOptions.length > 0) {
              channelOptions[0].selected = true;
              channelSelectBoxLabel = channelOptions[0].label;
            }

            const TemplateReplyButton = (
              <TemplateIcon>
                <Icon
                  name="template"
                  nameSelected="template-selected"
                  width={30}
                  height={30}
                  onClick={this.showModal}
                />
                {this.state.showModal && (
                  <TemplateReplyModal
                    text="Choose Template"
                    onCancel={this.hideModal}
                    onConfirm={this.hideModal}
                  />
                )}
              </TemplateIcon>
            );

            let Replying;
            if (selectedCase && selectedCase.channel.name === "twitter") {
              Replying = (
                <WrapperReply>
                  <TemplateReplySuggestion
                    textTyping={CaseManagementStore.message}
                  />
                  <Wrap>
                    <TextArea>
                      <Input
                        value={CaseManagementStore.message}
                        onChange={text => {
                          CaseManagementStore.message = text;
                        }}
                        onKeyUp={this.onInputEnter}
                      />
                    </TextArea>
                    <UserTwitter>
                      <p>
                        Replying to <Span>{CaseManagementStore.user}</Span>
                      </p>
                    </UserTwitter>
                  </Wrap>
                </WrapperReply>
              );
            } else {
              Replying = (
                <WrapperReply>
                  <TemplateReplySuggestion
                    textTyping={CaseManagementStore.message}
                  />
                  <Wrap>
                    <Input
                      value={CaseManagementStore.message}
                      onChange={text => {

                        CaseManagementStore.message = text;
                      }}
                      onKeyUp={this.onInputEnter}
                    />
                  </Wrap>
                </WrapperReply>
              );
            }

            return (
              <Wrapper>
                {CaseManagementStore.reply.id !== -1 && (
                  <Reply
                    name={CaseManagementStore.reply.name}
                    content={CaseManagementStore.reply.content}
                    onRemove={() => {
                      CaseManagementStore.reply = {
                        id: -1,
                        name: "",
                        content: ""
                      };
                    }}
                  />
                )}
                {Replying}
                <Bottom>
                  <ChannelLimit channel={channel.name} limit={limit} />
                  {nickActive && <Signature>-{signature}</Signature>}
                  {!nickActive && <Signature />}
                  {imageUrl && (
                    <Image
                      url={imageUrl}
                      onRemove={() => {
                        CaseManagementStore.imageUrl = null;
                      }}
                    />
                  )}

                  {/* {this.state.showOngkirButton && (
                    <Wrap>
                      <Icon name="price-tag" onClick={this.showOngkirModal} />
                      {this.state.showOngkirModal && (
                        <CekOngkirModal
                          text="Shipping Charge"
                          onCancel={this.hideOngkirModal}
                        />
                      )}
                    </Wrap>
                  )} */}
                  {approver.id !== -1 && (
                    <Approver
                      name={approver.name}
                      onRemove={() =>
                        (CaseManagementStore.approver = { id: -1, name: "" })
                      }
                    />
                  )}
                  <PickerAgent
                    position="top"
                    onSelected={this.onSelectApprover}
                  >
                    <div>
                      <Tooltip text="Approver">
                        <Icon name="agent-off" nameSelected="agent-selected" />
                      </Tooltip>
                    </div>
                  </PickerAgent>

                  {channel.name !== "instagram" && (
                    <div>
                      <label htmlFor="file">
                        <Tooltip text="Upload Image">
                          <Icon
                            name="image-off"
                            nameSelected="image-selected"
                            selected={imageUrl !== null}
                          />
                        </Tooltip>
                      </label>
                      <HiddenFileInput
                        id="file"
                        onChange={this.onImageUpload}
                      />
                    </div>
                  )}
                  {replyLabelActive && (
                    <LabelSelectBox
                      label={
                        replyLabels.length === 0
                          ? "No Label"
                          : `${replyLabels.length} Label(s)`
                      }
                      PickerComponent={LabelPicker}
                      selectedLabels={replyLabels.slice()}
                      position="top"
                      onSelected={selected => {
                        const index = replyLabels.findIndex(
                          label => label.value.id === selected.value.id
                        );
                        if (index !== -1) {
                          replyLabels.splice(index, 1);
                        } else {
                          replyLabels.push(selected);
                        }
                      }}
                    />
                  )}
                  <SelectBox
                    label={channelSelectBoxLabel}
                    PickerComponent={Picker}
                    options={channelOptions}
                    position="top"
                    onSelected={({ value: chType }) => {
                      CaseManagementStore.channelType = {
                        id: chType.id,
                        name: chType.name,
                        limit: chType.charLimit
                      };
                    }}
                    // disabled={channel.name === "facebook" ? true : false}
                  />

                  {channel.name === "livechat" ? (
                    <SelectBoxSendWhatsapp onClick={this.onSelectWhatsapp} />
                  ) : (
                    <SendButton onClick={this.onSend}>SEND</SendButton>
                  )}
                </Bottom>
              </Wrapper>
            );
          } else {
            return (
              <WrapperAssignButton>
                {!autoAssignActive && (
                  <AssignButton>+ ASSIGN TO ME</AssignButton>
                )}
              </WrapperAssignButton>
            );
          }
        }
      }

      onSelectWhatsapp = selected => {
        if (selected == "livechat") {
          this.onSend();
        } else if (selected == "whatsapp") {
          if (
            CaseManagementStore.message !== "" ||
            CaseManagementStore.imageUrl !== null
          ) {
            const caseId = CaseManagementStore.selectedCase.id;
            const { nickActive } = CommonStore;
            const signature = nickActive ? CommonStore.me.agent.shortName : "";
            const message = nickActive
              ? CaseManagementStore.message + ` -${signature}`
              : CaseManagementStore.message + ``;
            this.chatWithWhatsapp(caseId, message);
          }
        }
      };

      hideModal = () => {
        this.setState({ showModal: false });
      };
      showModal = () => {
        this.setState({ showModal: true });
      };

      showOngkirModal = () => {
        this.setState({ showOngkirModal: true });
      };

      hideOngkirModal = () => {
        this.setState({ showOngkirModal: false });
      };

      onSelectApprover = selected => {
        CaseManagementStore.approver = {
          id: selected.value.id,
          name: selected.label
        };
      };

      onImageUpload = event => {
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append("file", file);

        fetch(`${Config.apiUrl}/upload`, {
          method: "POST",
          headers: {
            Accept: "application/json"
          },
          body: formData
        })
          .then(response => response.text())
          .then(url => {
            CaseManagementStore.imageUrl = url;
          });
      };

      onInputEnter = event => {
        if(event.key === "Enter" && event.shiftKey) {
          console.log("Shift!!")
        } else {
          if (event.key === "Enter") {
            this.onSend();
            event.preventDefault();
          }
        }        
      };

      onSend = () => {
        if (
          CaseManagementStore.message !== "" ||
          CaseManagementStore.imageUrl !== null
        ) {
          const { nickActive } = CommonStore;
          const signature = nickActive ? CommonStore.me.agent.shortName : "";
          const usernameTwitter = CaseManagementStore.user;
          const replyMessage = [
            `${usernameTwitter}`, CaseManagementStore.message
          ].filter(item => item.length > 0).join(" ").trim();
          const message = nickActive
            ? replyMessage + ` -${signature}`
            : replyMessage + ``;
          const limit = CaseManagementStore.channelType.limit - message.length;
          if (limit < 0) return;
          const selected = CaseManagementStore.selectedCase;
          const caseId = selected.id;
          const imageUrl = CaseManagementStore.imageUrl;
          const channelTypeId = CaseManagementStore.channelType.id;
          const lastStream = selected.lastStream;
          let streamId = lastStream ? lastStream.id : 0;
          let replyMode = "IMPLICIT";
          if (CaseManagementStore.reply.id !== -1) {
            streamId = CaseManagementStore.reply.id;
            replyMode = "EXPLICIT";
          }
          const approver = CaseManagementStore.approver;
          let categoryLabelInput = [];
          for (const label of CaseManagementStore.replyLabels) {
            categoryLabelInput.push({ id: label.value.id });
          }
          categoryLabelInput =
            categoryLabelInput.length > 0 ? categoryLabelInput : null;
          if (approver.id === -1) {
            const { replyLabelActive } = CommonStore;
            const { replyLabels } = CaseManagementStore;
            if (replyLabelActive && replyLabels.length === 0) {
              ShowNotice("reply-label-missing-error");
            } else {
              this.sendReply(
                caseId,
                streamId,
                message,
                channelTypeId,
                imageUrl,
                replyMode,
                categoryLabelInput
              );
            }
          } else {
            this.sendEscalate(caseId, streamId, message, approver.id, imageUrl);
          }
        } else {
          ShowNotice("reply-message-error");
        }
        ResetMessage();
      };

      sendReply = async (
        caseId,
        streamId,
        message,
        channelTypeId,
        imageUrl,
        replyMode,
        categoryLabelInput
      ) => {
        try {
          const { data: { replyToCase: newStream } } =  await this.props.sendMutate({
            variables: {
              case: {
                id: caseId
              },
              stream: {
                id: streamId
              },
              content: message,
              channelSpecificType: {
                id: channelTypeId
              },
              image: imageUrl,
              replyMode: replyMode,
              categoryLabelInput: categoryLabelInput
            }
          });

          // scroll to bottom
          const scrollRef = CaseManagementStore.messageScrollBarRef;
          if (scrollRef) scrollRef.scrollToBottom();
          pushNewStream(newStream)  
          // show success notification
          ShowNotice("reply-success");
        } catch (error) {
          ShowNotice("reply-error");
        }
      };

      sendEscalate = async (caseId, streamId, message, agentId, imageUrl) => {
        try {
          await this.props.escalateMutate({
            variables: {
              case: {
                id: caseId
              },
              stream: {
                id: streamId
              },
              content: message,
              agent: {
                id: agentId
              },
              image: imageUrl
            }
          });
          ShowNotice("escalate-success");
        } catch (error) {
          ShowNotice("escalate-error");
        }
      };

      // Mutasi Chat With Whatsapp
      chatWithWhatsapp = async (caseId, content) => {
        try {
          await this.props.chatWithWhatsapp({
            variables: {
              case: {
                id: caseId
              },
              content: content
            }
          });
        } catch (error) {
          ShowNotice("invoke-whatsapp-error");
        }
      };
    }
  )
);

const LabelSelectBox = styled(SelectBox)`
  margin-right: 5px;
`;
const Wrapper = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
`;
const WrapperReply = styled.div`
  display: flex;
  flex-direction: column;
  flex: none;
`;
const Bottom = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 50px;
  padding: 0 16px;
`;
const Signature = styled.span`
  font-size: 0.8rem;
  color: ${props => props.theme.uiText};
  margin-left: 4px;
  margin-right: auto;
`;
const Icon = styled(IconRaw)`
  margin-right: 10px;
`;
const SendButton = styled.button`
  display: flex;
  padding: 8px;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: none;
  border-radius: 20px;
  color: white;
  transition: 0.3s;
  cursor: pointer;
  font-size: 0.8rem;
  padding: 5px 15px;
  margin-left: 10px;
  background-color: ${props => props.theme.blueButton};
  &:focus {
    outline: none;
  }
  &:hover {
    opacity: 0.7;
  }
`;
const HiddenFileInput = styled.input.attrs({
  type: "file",
  accept: "image/*"
})`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
`;

const Wrap = styled.section`
  position: relative;
  display: inline-block;
`;

const UserTwitter = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  padding-left: 8px;
  padding-top: 8px;
`;
const Span = styled.span`
  color: #338dca;
`;
const TextArea = styled.section`
  border-top: 1px solid #d2d3d5;
  padding-top: 30px;
`;

const TemplateIcon = styled.div`
  position: absolute;
  right: 8px;
  bottom: 40px;
`;
// const TemplateReplyWrapper = styled.div`
//   display: flex;
//   flex-direction: row;
//   margin: 5px 10px 10px 10px;
//   background-color: transparent;
// `;

const WrapperAssignButton = styled.div``;



// WEBPACK FOOTER //
// ./src/module-case-management/content-panel/footer/FooterWithStoreMutation.js